// src/components/AvatarSVG.jsx
export default function AvatarSVG({ name, className = "w-9 h-9" }) {
  const [a = "", b = ""] = (name || "").split(" ");
  const initials = (a[0] || "").toUpperCase() + (b[0] || "").toUpperCase();
  const palette = ["#0ea5e9", "#1e40af", "#16a34a", "#9333ea", "#f59e0b", "#ef4444"];
  const color = palette[(name?.length || 0) % palette.length];

  return (
    <svg viewBox="0 0 112 112" className={`${className} rounded-full shadow`} aria-hidden="true">
      <circle cx="56" cy="56" r="56" fill={color} />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="40"
        fontWeight="700"
        fill="#ffffff"
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto"
      >
        {initials || "U"}
      </text>
    </svg>
  );
}
